module.exports = __webpack_public_path__ + "static/14-insights-c7d6c39ad5ff8ebddc81635c2ac4a5aa.jpg";